var jQuery = require('jquery');
require('jquery.scrollbar');
require('scrollbar-css');
jQuery(document).ready(function($) {

  // scrollbar for reviews tabs
  jQuery('.scrollbar-inner').scrollbar();

  // single product review tabs
  var $sections = $('.review-tabs .content');
  var $navItems = $('.review-tabs .tabs .tab[data-target]');

  $navItems.on('click', function(event) {
    var $this = $(event.target);
    var $section = $('#' + $this.data('target'));

    $section.removeClass('is-hidden');
    $section.addClass('is-visible');
    $sections.not($section).removeClass('is-visible').addClass('is-hidden');

    $this.addClass('active');
    $navItems.not($this).removeClass('active');
  });

});



//////////////////
// WEBPACK FOOTER
// ./views/js/single-product.js
// module id = 20
// module chunks = 1